export const ONE_SECOND = 1000
export const ONE_MINUTE = 1000 * 60
